import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
  Icon,
  Input,
  Label,
  Text,
} from '@mntn/ui-components'
import type React from 'react'
import { useCallback } from 'react'
import { useFilter } from '../context/filter-context'

export const CpmRangeFilter: React.FC = () => {
  const { filters, updateFilter, isSectionOpen, toggleSection } = useFilter()
  const isOpen = isSectionOpen('cpm-range')

  const currentValue = filters.cpmRange || { min: undefined, max: undefined }
  const minValue = currentValue.min !== undefined ? String(currentValue.min) : ''
  const maxValue = currentValue.max !== undefined ? String(currentValue.max) : ''

  const handleMinChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const newMinValue = e.target.value
      const parsedMin = newMinValue === '' ? undefined : Number(newMinValue) || undefined

      updateFilter('cpmRange', {
        ...currentValue,
        min: parsedMin,
      })
    },
    [updateFilter, currentValue],
  )

  const handleMaxChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const newMaxValue = e.target.value
      const parsedMax = newMaxValue === '' ? undefined : Number(newMaxValue) || undefined

      updateFilter('cpmRange', {
        ...currentValue,
        max: parsedMax,
      })
    },
    [updateFilter, currentValue],
  )

  const selectedCount = currentValue.min !== undefined || currentValue.max !== undefined ? 1 : 0

  return (
    <Accordion
      type="single"
      collapsible
      value={isOpen ? 'cpm-range' : ''}
      onValueChange={() => toggleSection('cpm-range')}
      className="w-full"
    >
      <AccordionItem value="cpm-range" className="border-0">
        <AccordionTrigger className="p-6 border-b border-borders-primary hover:no-underline">
          <div className="flex items-center justify-between w-full">
            <div className="flex items-center gap-2">
              <Text variant="lg-sb">CPM Range</Text>
              {selectedCount > 0 && (
                <div className="bg-primary text-header-inverse rounded-full px-2 py-1 text-xs font-medium">
                  {selectedCount}
                </div>
              )}
            </div>
            <Icon
              name={isOpen ? 'Minus' : 'Plus'}
              className="h-6 w-6 text-primary shrink-0 transition-transform duration-200"
            />
          </div>
        </AccordionTrigger>
        <AccordionContent className="p-6 border-b border-borders-primary">
          <div className="w-full flex items-center justify-between gap-4">
            <div className="flex-1">
              <Label htmlFor="cpm-min" className="text-sm font-medium text-header mb-2 block">
                Min
              </Label>
              <Input
                id="cpm-min"
                data-testid="cpm-min-input"
                name="cpm-min"
                type="number"
                step={0.01}
                inputMode="numeric"
                inputClassName="pl-8"
                value={minValue}
                onChange={handleMinChange}
                iconLeft="$"
                placeholder="0.00"
              />
            </div>
            <div className="flex-1">
              <Label htmlFor="cpm-max" className="text-sm font-medium text-header mb-2 block">
                Max
              </Label>
              <Input
                id="cpm-max"
                data-testid="cpm-max-input"
                name="cmp-max"
                type="number"
                step={0.01}
                inputMode="numeric"
                inputClassName="pl-8"
                value={maxValue}
                onChange={handleMaxChange}
                iconLeft="$"
                placeholder="0.00"
              />
            </div>
          </div>
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  )
}
